import React, { useEffect, useState } from 'react';
import _ from 'lodash';
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../../../../../hooks/hooks';
import PageLoader from '../../../../../../components/PageLoader';
import { financialYears } from '../../../../../../redux/fms/financial-years/action';
import { selectFinancialYearsQueryItems } from '../../../../../../redux/fms/financial-years/selector';
import FinancialYearComponent from '../components/financial-year.component';

const ManagementFinancialYear = () => {
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const parmas: any = useParams()
  const financialYearsQueryData = useSelector(selectFinancialYearsQueryItems)
  const [isQuery, setIsQuery] = useState<boolean>(false)
  const [selectedFinancialYears, setSelectedFinancialYears] = useState<any>([])

  const fetchFinancialYearsQueryById = () => {
    dispatch(financialYears.query({
      url: `https://fms.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/e-applications/fms/financial-years/query`,
      entity: 'financialYears',
      jsonData:
      {
        Records: [
          {
            "Id": parmas?.id
          }
        ]
      }
    })).then(() => {
      setIsQuery(true)
    })
  }

  const handleInnerFormChange: any = (event: any, field: string) => {
    setSelectedFinancialYears({ ...selectedFinancialYears, [field]: event });
  }

  useEffect(() => {
    if (parmas?.id > 0) {
      fetchFinancialYearsQueryById()
    }
  }, [])

  useEffect(() => {
    if (isQuery) {
      setSelectedFinancialYears(financialYearsQueryData?.result?.items)
    }
  }, [isQuery])

  const handleFormSubmit = async (event: any) => {
    event.preventDefault();
    if (parmas?.id > 0) {
      await dispatch(financialYears.resetAction({ actionType: 'update' }))
      await dispatch(financialYears.update({
        url: `https://fms.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/e-applications/fms/financial-years`,
        entity: 'financialYears',
        jsonData:
        {
          Records: [
            {
              ...selectedFinancialYears
            }
          ]
        }
      })).then(() => {
        back()
      })
    } else {
      await dispatch(financialYears.resetAction({ actionType: 'create' }))
      await dispatch(financialYears.create({
        url: `https://fms.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/e-applications/fms/financial-years`,
        entity: 'financialYears',
        jsonData:
        {
          Records: [
            {
              ...selectedFinancialYears
            }
          ]
        }
      })).then(() => {
        back()
      })
    }
  }

  const back = () => {
    navigate('/management/e-applications/fms/financial-years')
  }

  return (
    <>
      {financialYearsQueryData?.isLoading ? <PageLoader /> :
        <FinancialYearComponent
          handleInnerFormChange={handleInnerFormChange}
          selectedFinancialYears={selectedFinancialYears}
          back={back}
          handleFormSubmit={handleFormSubmit}
          id={parmas?.id}
        />
      }
    </>
  )
}

export default ManagementFinancialYear;